import { TourType } from '@react-admin/ra-tour';

import { useGetWelcomeTour } from '@Components/Layout/tours/WelcomeTour';
import { BoExternalIdentityI } from '@Utils/providers/authProvider';

export const useGetTours = ({
  identity,
}: {
  identity: BoExternalIdentityI | undefined;
}): { [id: string]: TourType } => {
  const companyId = identity ? identity.companyId.at(0) : null;

  return {
    'welcome-tour': useGetWelcomeTour({
      companyId: companyId ?? null,
    }),
  };
};
